<template>
    <div>
        <b-modal ref="modal" @hide="hide" @show="show" id="cancelOrder_modal" hide-footer centered size="lg"  modal-class="changeOrder cancelOrder">
            <ModalTopContentShare :modalTopContent="orderDetail" />
            <form>
                <div v-if="showAccountInput" class="user_account"><!-- 預設為v-if="!showAccountInput" -->
                    <h3>付款帳戶</h3>
                    <div class="row">
                        <div class="col-12 col-sm-4">
                            <h5>帳戶名稱</h5>
                            <input v-model="bankAccountName" type="text" placeholder="請輸入帳戶名稱" v-validate="'required'" name="bank_account_name" class="store_input">
                            <div class="errors_box">
                                <span>{{ errors.first('bank_account_name') }}</span>
                            </div>
                        </div>
                        <div class="col-12 col-sm-4">
                            <h5>銀行代碼</h5>
                            <v-select v-model="bank" :options="bankOptions" v-validate="'required'" name="bank_id" class="store_input vue_store_input" placeholder="請選擇銀行代碼"></v-select>
                            <div class="errors_box">
                                <span>{{ errors.first('bank_id') }}</span>
                            </div>
                        </div>
                        <div class="col-12 col-sm-4">
                            <h5>銀行帳戶</h5>
                            <input v-model="bankAccount" type="text" placeholder="請輸入銀行帳戶" v-validate="'required|numeric'" name="bank_account" class="store_input">
                            <div class="errors_box">
                                <span>{{ errors.first('bank_account') }}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="showATMAccount" class="refundAccount">
                    <div class="row">
                        <div class="col-auto align-self-center">
                            <h4>付款帳戶</h4>
                        </div>
                        <div class="col-auto align-self-center">
                            <p>{{ atmAccount }}</p>
                        </div>
                    </div>
                </div>
                <div class="cancelOrder_btn">
                    <div class="row justify-content-end">
                        <div class="col-sm-4">
                            <div class="row justify-content-around">
                                <div class="col-6 text-right align-self-center">
                                    <p>退款金額</p>
                                </div>
                                <div class="col-6 align-self-center">
                                    <p class="num">{{ orderDetail.RefundPrice | currency }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row justify-content-center">
                        <div class="col-auto">
                            <button class="hoverFill" type="button" @click="hide">返回離開</button>
                        </div>
                        <div class="col-auto">
                            <button class="hoverShallow" type="button" @click="submit">確定取消</button>
                        </div>
                    </div>
                </div>
            </form>
        </b-modal>
    </div>
</template>

<script>
    import vSelect from 'vue-select'
    import ModalTopContentShare from '@/components/modal/ModalTopContentShare'
    import { mapGetters, mapActions } from 'vuex'
    import orderApi from '@/api/order'
    import _ from 'lodash'

    export default {
        components: {
            ModalTopContentShare,
            vSelect,
        },
        data() {
            return {
                bank: undefined,
                bankAccount: undefined,
                bankAccountName: undefined,
                bankList: [],
            }
        },
        computed: {
            ...mapGetters('orderDetail', [
                'orderDetail',
                'showCancelModal',
            ]),
            bankOptions() {
                return this.bankList.map((bank) => {
                    return {
                        label: `${bank.BankID} ${bank.BankName}`,
                        value: bank.BankID,
                    };
                });
            },
            payType() {
                return _.get(this.orderDetail, 'PayType');
            },
            payStatus() {
                return _.get(this.orderDetail, 'PayStatus');
            },
            atmAccount() {
                return _.get(this.orderDetail, 'ATMAccount');
            },
            showAccountInput() {
                if ((this.payType == 4 || this.payType == 5) && this.payStatus == 1) {
                    return true;
                }

                return false;
            },
            showATMAccount() {
                if (this.payStatus == 0 && this.atmAccount) {
                    return true;
                }

                return false;
            },
        },
        created() {
            let attributes = {
                bank_id: '銀行代碼',
                bank_account: '銀行帳戶',
                bank_account_name: '帳戶名稱',
            };

            const dict = {
                attributes,
            };

            this.$validator.localize('zh_TW', dict);
        },
        watch: {
            showCancelModal(val) {
                if (val) {
                    this.$refs.modal.show();
                } else {
                    this.$refs.modal.hide();
                }
            },
        },
        methods: {
            ...mapActions('orderDetail', [
                'hide',
                'cancelOrderDetail'
            ]),
            submit() {
                this.$validator.validateAll().then((result) => {
                    if (result) {
                        this.cancelOrderDetail({
                            BankID: _.get(this.bank, 'value'),
                            BankAccount: this.bankAccount,
                            BankAccountName: this.bankAccountName,
                        });
                    }
                });
            },
            getBankList() {
                // if (!this.showAccountInput) return;
                if (this.bankList.length) return;

                this.bankList = [];
                orderApi.bankList((data) => {
                    this.bankList = data ? data : [];
                });
            },
            show() {
                this.reset();
                this.getBankList();
            },
            reset() {
                this.bank = undefined;
                this.bankAccount = undefined;
                this.bankAccountName = undefined;
            },
        },
    }
</script>

